import httpRequestConstants from '@/assets/js/http-request-constants';

export default {
    BASE: {
        //关联话题
        GET_TOPIC_PAGE: {
            path: '/buick-ev/mgt/common/topic/page',
            resourceId: 'GET_TOPIC_PAGE',
            method: httpRequestConstants.METHOD_POST
        },
        // 按条件检索卡券类型
        DICT_TYPE: {
            path: '/buick-ev/mgt/common/dict/',
            resourceId: 'DICT_TYPE',
            method: httpRequestConstants.METHOD_GET
        },
        // 经销商
        COMMON_DEALER: {
            path: '/buick-ev/mgt/common/dealer',
            resourceId: 'COMMON_DEALER',
            method: httpRequestConstants.METHOD_GET
        },
        // 车系
        COMMON_SERIES: {
            path: '/buick-ev/mgt/common/series',
            resourceId: 'COMMON_SERIES',
            method: httpRequestConstants.METHOD_GET
        },
        // store
        COMMON_STORE: {
            path: '/buick-ev/mgt/verify/getDealers',
            resourceId: 'COMMON_STORE',
            method: httpRequestConstants.METHOD_POST
        },
        // 城市
        COMMON_CITY: {
            path: '/buick-ev/mgt/common/city',
            resourceId: 'COMMON_CITY',
            method: httpRequestConstants.METHOD_GET
        },
        // 上传
        FILE_UPLOAD: {
            path: '/buick-ev/mgt/file/upload',
            resourceId: 'FILE_UPLOAD',
            method: httpRequestConstants.METHOD_POST
        },
        // 下载
        GET_FILE: {
            path: '/buick-ev/mgt/file/',
            resourceId: 'GET_FILE',
            method: httpRequestConstants.METHOD_GET
        },
        // 获取问卷模版列表
        GET_QUESTIONNAIRE: {
            path: '/buick-ev/mgt/common/questionnaire/templates',
            resourceId: 'GET_QUESTIONNAIRE',
            method: httpRequestConstants.METHOD_GET
        },
        // 品牌
        GET_AUTHORITY_DETAIL: {
            path: '/buick-ev/mgt/common/authority/detail',
            resourceId: 'GET_AUTHORITY_DETAIL',
            method: httpRequestConstants.METHOD_GET
        }
    },

    ACTIVITY: {
        // 活动管理列表
        SIGN_UP_GET_LIST: {
            path: '/buick-ev/mgt/activity/page',
            resourceId: 'SIGN_UP_GET_LIST',
            method: httpRequestConstants.METHOD_POST
        },
        // 活动数据导出
        ACTIVITY_GET_EXPORT: {
            path: '/buick-ev/mgt/activity/export',
            resourceId: 'ACTIVITY_GET_EXPORT',
            method: httpRequestConstants.METHOD_POST
        },
        // 活动报名数据导出
        ACTIVITY_SIGN_UP_EXPORT: {
            path: '/buick-ev/mgt/file/partake/exportByActivitySession',
            resourceId: 'ACTIVITY_SIGN_UP_EXPORT',
            method: httpRequestConstants.METHOD_POST
        },
        // 删除活动
        DELETE_ID: {
            path: '/buick-ev/mgt/activity/',
            resourceId: 'DELETE_ID',
            method: httpRequestConstants.METHOD_DELETE
        },
        // 新增活动
        SIGN_UP: {
            path: '/buick-ev/mgt/activity',
            resourceId: 'SIGN_UP',
            method: httpRequestConstants.METHOD_POST
        },
        // 新增模版
        FIELDS: {
            path: '/buick-ev/mgt/fields/',
            resourceId: 'FIELDS',
            method: httpRequestConstants.METHOD_POST
        },
        // 查询模版
        GET_FIELDS: {
            path: '/buick-ev/mgt/fields/',
            resourceId: 'GET_FIELDS',
            method: httpRequestConstants.METHOD_GET
        },
        // 查看活动详情------
        GET_ACTIVITY: {
            path: '/buick-ev/mgt/activity/activityDetail',
            resourceId: 'GET_ACTIVITY',
            method: httpRequestConstants.METHOD_POST
        },
        // 更新活动------
        PUT_ACTIVITY: {
            path: '/buick-ev/mgt/activity/activityUpdate',
            resourceId: 'PUT_ACTIVITY',
            method: httpRequestConstants.METHOD_POST
        },
        // 更新活动置顶------
        PUT_ACTIVITY_TOP_FLAG: {
            path: '/buick-ev/mgt/activity/activityTopFlagChange',
            resourceId: 'PUT_ACTIVITY_TOP_FLAG',
            method: httpRequestConstants.METHOD_POST
        },
        // 新增场次------
        SESSIONS: {
            path: '/buick-ev/mgt/sessions/activity/saveSession/',
            resourceId: 'SESSIONS',
            method: httpRequestConstants.METHOD_POST
        },
        // id查询场次------
        GET_ID_SESSIONS: {
            path: '/buick-ev/mgt/sessions/sessionDetail/',
            resourceId: 'GET_ID_SESSIONS',
            method: httpRequestConstants.METHOD_POST
        },
        // 更新场次------
        PUT_SESSIONS: {
            path: '/buick-ev/mgt/sessions/sessionUpdate',
            resourceId: 'PUT_SESSIONS',
            method: httpRequestConstants.METHOD_POST
        },
        // 查询场次
        GET_SESSIONS: {
            path: '/buick-ev/mgt/sessions/query',
            resourceId: 'GET_SESSIONS',
            method: httpRequestConstants.METHOD_POST
        },
        // 取消场次
        PUT_STATE_SESSIONS: {
            path: '/buick-ev/mgt/sessions/cancel/',
            resourceId: 'PUT_STATE_SESSIONS',
            method: httpRequestConstants.METHOD_PUT
        },
        // 查询场次票据
        GET_PARTAKET_TICKET: {
            path: '/buick-ev/mgt/partake/partakeTicket',
            resourceId: 'GET_PARTAKET_TICKET',
            method: httpRequestConstants.METHOD_POST
        },
        // 修改场次票据
        UPDATE_PARTAKET_TICKET: {
            path: '/buick-ev/mgt/partake/updateTicket',
            resourceId: 'UPDATE_PARTAKET_TICKET',
            method: httpRequestConstants.METHOD_POST
        },
        // 查询核销人员分页
        GET_VERIFY_PAGE: {
            path: '/buick-ev/mgt/verify/page',
            resourceId: 'GET_VERIFY_PAGE',
            method: httpRequestConstants.METHOD_POST
        },
        // 创建核销人员
        CREATE_VERIFY: {
            path: '/buick-ev/mgt/verify/create',
            resourceId: 'CREATE_VERIFY',
            method: httpRequestConstants.METHOD_POST
        },
        // 编辑核销人员
        UPDATE_VERIFY: {
            path: '/buick-ev/mgt/verify/update',
            resourceId: 'UPDATE_VERIFY',
            method: httpRequestConstants.METHOD_POST
        },
        // 删除核销人员
        DELETE_VERIFY: {
            path: '/buick-ev/mgt/verify/delete',
            resourceId: 'DELETE_VERIFY',
            method: httpRequestConstants.METHOD_POST
        },
        // 查询门店分页
        GET_DEALER_PAGE: {
            path: '/buick-ev/mgt/verify/getDealers',
            resourceId: 'GET_DEALER_PAGE',
            method: httpRequestConstants.METHOD_POST
        },
        // 查询商品分页
        GET_PRODUCT_PAGE: {
            path: '/buick-ev/mgt/sessions/msc/page',
            resourceId: 'GET_PRODUCT_PAGE',
            method: httpRequestConstants.METHOD_POST
        },
        // 停止报名
        STOP_ENROLL_SESSION: {
            path: '/buick-ev/mgt/sessions/enroll/',
            resourceId: 'STOP_ENROLL_SESSION',
            method: httpRequestConstants.METHOD_PUT
        },
        // 查询报名列表
        POST_APPLICATIONS_QUERY: {
            path: '/buick-ev/mgt/partake/query',
            resourceId: 'POST_APPLICATIONS_QUERY',
            method: httpRequestConstants.METHOD_POST
        },
        // 报名信息统计
        GET_APPLICATIONS_STATISTICS: {
            path: '/buick-ev/mgt/partake/stat/',
            resourceId: 'GET_APPLICATIONS_STATISTICS',
            method: httpRequestConstants.METHOD_GET
        },
        // FIXME
        // 上传报名信息
        POST_PARTAKE: {
            path: '/buick-ev/mgt/file/partake/audit/',
            method: httpRequestConstants.METHOD_POST
        },
        // FIXME
        // 上传审核下发接口
        PUT_PARTAKE_STATE: {
            path: '/buick-ev/mgt/partake/audit/',
            resourceId: 'PUT_PARTAKE_STATE',
            method: httpRequestConstants.METHOD_PUT
        },
        // FIXME
        // 导出报名数据
        APPLICATIONS_EXPORT_EXECL: {
            path: '/buick-ev/mgt/file/partake/export',
            method: httpRequestConstants.METHOD_POST
        },
        //报名批量导出
        BATCH_EXPORT_EXECL: {
            path: '/buick-ev/mgt/file/partake/exportBySession',
            resourceId:'BATCH_EXPORT_EXECL',
            method: httpRequestConstants.METHOD_POST
        },
        //白名单列表
        WHITE_LIST:{
            path: '/buick-ev/mgt/common/admin',
            resourceId: 'WHITE_LIST',
            method: httpRequestConstants.METHOD_GET
        },
        // 查看二维码
        POST_QRCODE: {
            path: '/buick-ev/mgt/sessions/qrcode/',
            resourceId: 'POST_QRCODE',
            method: httpRequestConstants.METHOD_GET
        },
        // 健康码下载
        PARTAKE_QREXPORT: {
            path: '/buick-ev/mgt/file/partake/qrexport/',
            method: httpRequestConstants.METHOD_GET
        },
        //场次预览
        SESSIONS_PREVIEW:{
            path: '/buick-ev/mgt/sessions/preview/',
            resourceId: 'SESSIONS_PREVIEW',
            method: httpRequestConstants.METHOD_POST
        },
        //手工批量核销
        BUICK_VERIFY:{
            path: '/buick-ev/mgt/file/partake/bulkVerify/',
            resourceId: 'BUICK_VERIFY',
            method: httpRequestConstants.METHOD_POST
        },
        //投票问卷
        SQC_LIST:{
            path: '/buick-ev/mgt/sessions/sqc/getSqcList',
            resourceId: 'SQC_LIST',
            method: httpRequestConstants.METHOD_POST
        },
        QUERY_BOW_LIST:{
            path: '/buick-ev/mgt/sessions/queryBOWList',
            resourceId: 'QUERY_BOW_LIST',
            method: httpRequestConstants.METHOD_POST
        },
        //白名单
        UPLOAD_BOW_LIST:{
            path: '/buick-ev/mgt/sessions/importBOWList',
            resourceId: 'UPLOAD_BOW_LIST',
            method: httpRequestConstants.METHOD_POST
            //ContentType: 'multipart/form-data'
        },
        DELETE_BOW_LIST:{
            path: '/buick-ev/mgt/sessions/deleteBOWList',
            resourceId: 'DELETE_BOW_LIST',
            method: httpRequestConstants.METHOD_POST,
        },
        QUERY_RATE_LIST:{
            path: '/buick-ev/mgt/sessions/getRating',
            resourceId: 'QUERY_RATE_LIST',
            method: httpRequestConstants.METHOD_POST
        },
        UPLOAD_SIGNUP_REVIEW:{
            path: '/buick-ev/mgt/partake/check/sessionCode',
            resourceId: 'UPLOAD_SIGNUP_REVIEW',
            method: httpRequestConstants.METHOD_PUT
        }
    },
    // 线索
    CLUE: {
        // 文件上传线索下发
        UPLOAD: {
            path: '/buick-ev/mgt/file/doss/upload',
            method: httpRequestConstants.METHOD_POST
        }
    },
    MATERIAL:{
        SAVE_MATERIAL:{
            //动过
            path: '/buick-ev/mgt/index/images/',
            resourceId: 'SAVE_MATERIAL',
            method: httpRequestConstants.METHOD_POST
        },
        GET_MATERIAL:{
            //动过
            path: '/buick-ev/mgt/index/images/',
            resourceId: 'GET_MATERIAL',
            method: httpRequestConstants.METHOD_GET
        },
        BAOCUN:{
            path: '/buick-ev/mgt/file/index/image',
            resourceId: 'BAOCUN',
            method: httpRequestConstants.METHOD_POST
        },
        //创建，编辑视频
        SAVE_VIDEO:{
            path: '/buick-ev/mgt/video/createOrUpdate',
            resourceId: 'SAVE_VIDEO',
            method: httpRequestConstants.METHOD_POST
        },
        //视频列表
        GET_VIDEO_LIST:{
            path: '/buick-ev/mgt/video/query',
            resourceId: 'GET_VIDEO_LIST',
            method: httpRequestConstants.METHOD_POST
        },
        //删除视频
        DELETE_VIDEO:{
            path: '/buick-ev/mgt/video/',
            resourceId: 'DELETE_VIDEO',
            method: httpRequestConstants.METHOD_DELETE
        },
        //置顶视频
        SET_TOP:{
            path: '/buick-ev/mgt/video/',
            resourceId: 'SET_TOP',
            method: httpRequestConstants.METHOD_PUT
        },
        //详情视频
        DETAIL_VIDEO:{
            path: '/buick-ev/mgt/video/',
            resourceId: 'DETAIL_VIDEO',
            method: httpRequestConstants.METHOD_GET
        },
        //发现页图片保存,(改动)
        SAVE_FINDPIC:{
            path: '/buick-ev/mgt/found/image/',
            resourceId: 'SAVE_FINDPIC',
            method: httpRequestConstants.METHOD_POST
        },
        //编辑发现页图片
            EDIT_FINDPIC:{
            path: '/buick-ev/mgt/found/image/',
            resourceId: 'EDIT_FINDPIC',
            method: httpRequestConstants.METHOD_PUT
        }

    },
    PICTURE: {
        // 照片列表查询
        GET_PICTURE: {
            path: '/buick-ev/mgt/sessions/image/',
            resourceId: 'GET_PICTURE',
            method: httpRequestConstants.METHOD_GET
        },
        // 上传照片
        UPLOAD_PICTURE: {
            path: '/buick-ev/mgt/file/session/upload',
            method: httpRequestConstants.METHOD_POST
        },
        // 删除照片列表图片
        DELETE_IDARRRAY: {
            path: '/buick-ev/mgt/sessions/image',
            resourceId: 'DELETE_IDARRRAY',
            method: httpRequestConstants.METHOD_DELETE
        },
        // 获取活动下拉字典
        GET_ACTIVITYDIC: {
            path: '/buick-ev/mgt/activity/list',
            resourceId: 'GET_ACTIVITYDIC',
            method: httpRequestConstants.METHOD_POST
        },
        // 获取场次下拉字典
        GET_SESSIONSDIC: {
            path: '/buick-ev/mgt/sessions/list',
            resourceId: 'GET_SESSIONSDIC',
            method: httpRequestConstants.METHOD_POST
        },
        // 图片确认下发
        SEND_MESSAGE: {
            path: '/buick-ev/mgt/sessions/image/notification/',
            resourceId: 'SEND_MESSAGE',
            method: httpRequestConstants.METHOD_POST
        }
    },
    // PERMISSION : {
    //     // 应用权限分页
    //     GET_APP_PERMISSION_PAGE: {
    //         path: '/cfc-portal/rest/api/protect/authority/page',
    //         resourceId: 'GET_APP_PERMISSION_PAGE',
    //         method: httpRequestConstants.METHOD_POST
    //     },
    //     // 编辑应用权限
    //     UPDATE_ROLE_AUTHORITY: {
    //         path: '/cfc-portal/rest/api/protect/authority/update',
    //         resourceId: 'UPDATE_ROLE_AUTHORITY',
    //         method: httpRequestConstants.METHOD_POST
    //     },
    //     // 创建应用权限
    //     CREATE_ROLE_AUTHORITY: {
    //         path: '/cfc-portal/rest/api/protect/authority/create',
    //         resourceId: 'CREATE_ROLE_AUTHORITY',
    //         method: httpRequestConstants.METHOD_POST
    //     }
    // }
};
